<!-- HistorialEnvios.vue — Intentos previos de envío por WhatsApp -->
<!-- Solo se muestra si hubo más de un envío del mismo tipo. -->
<template>
  <details v-if="mensajes.length" class="historial">
    <summary class="historial-titulo">
      <i class="bi bi-clock-history me-1"></i>
      {{ titulo }} ({{ mensajes.length }})
    </summary>
    <div class="historial-lista">
      <div v-for="m in mensajes" :key="m.id" class="historial-row">
        <span class="historial-badge" :class="presentacion(m.estatus).clase">
          <i class="bi" :class="presentacion(m.estatus).icono"></i>
          {{ presentacion(m.estatus).label }}
        </span>
        <span class="historial-fecha">{{ formatFechaHora(m.fecha_creacion) }}</span>
        <span v-if="m.enviado_por_nombre" class="historial-autor">
          {{ m.enviado_por_nombre }}
        </span>
        <span v-if="textoError(m)" class="historial-error">{{ textoError(m) }}</span>
      </div>
    </div>
  </details>
</template>

<script setup>
import {
  presentacion,
  textoError,
  formatFechaHora,
} from "./composables/useMensajesWhatsapp.js";

defineProps({
  mensajes: { type: Array, default: () => [] },
  titulo: { type: String, default: "Envíos anteriores" },
});
</script>

<style scoped>
.historial {
  margin-top: 4px;
}
.historial-titulo {
  font-size: 0.75rem;
  font-weight: 700;
  color: rgba(64, 34, 8, 0.55);
  cursor: pointer;
  padding: 4px 0;
}
.historial-lista {
  padding: 6px 0 0 12px;
}
.historial-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 0.74rem;
  padding: 3px 0;
  border-bottom: 1px solid rgba(64, 34, 8, 0.06);
}
.historial-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 700;
}
.historial-badge.wa-entregado,
.historial-badge.wa-leido {
  color: #2e7d32;
}
.historial-badge.wa-enviado {
  color: #1565c0;
}
.historial-badge.wa-fallido {
  color: #c62828;
}
.historial-badge.wa-pendiente,
.historial-badge.wa-aceptado {
  color: #6d4c41;
}
.historial-fecha,
.historial-autor {
  color: rgba(64, 34, 8, 0.5);
}
.historial-error {
  color: #c62828;
  flex-basis: 100%;
}
</style>
